import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgKlussenInJeWoning = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#FBDCEE"
      d="M25.258 25.896 13.945 14.583l-8.11 8.11 11.313 11.314z"
    />
    <path
      fill="#F170B8"
      d="m26.06 20.32 1.95 1.95c.24.24.24.64 0 .88l-2.74 2.74-11.31-11.31 2.74-2.74c.24-.24.64-.24.88 0l1.95 1.95c.28.28.66.44 1.05.44 1.59 0 3.07-.82 3.92-2.17.66-1.06 1.19-2.21 1.58-3.36.28-.83.84-1.59 1.7-2.13 1.25-.78 2.9-.79 4.15 0a4.01 4.01 0 0 1 .76 6.26c-.46.46-1.01.79-1.6.97-1.11.35-2.32.93-3.41 1.63-1.3.84-2.07 2.3-2.07 3.85 0 .4.16.78.44 1.05zm3.1-9.63a.996.996 0 1 0 1.41-1.41.996.996 0 1 0-1.41 1.41M8.65 19.88l-2.83 2.83 11.31 11.31 2.83-2.83c0-2.83-2.83 0-4.24-1.41s2.83-2.83 1.41-4.24-2.83 2.83-4.24 1.41 1.41-1.41 0-2.83-1.41 1.41-2.83 0 2.83-4.24-1.41-4.24"
    />
    <path
      fill="#00215B"
      d="m24.25 25.56-6.35-6.35.71-.71 5.65 5.65 2.3-2.3c.62-.62.62-1.64 0-2.27l.71-.71a2.613 2.613 0 0 1 0 3.68l-3.01 3.01z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgKlussenInJeWoning);

export default ForwardRef;
